import React from "react";

export const LayoutContext = React.createContext();
export const useLayout = () => React.useContext(LayoutContext);

export const LayoutProvider = ({children}) => {
  const [isSidebarOpened, setIsSidebarOpened] = React.useState(true);
  
  return (
    <LayoutContext.Provider
      value={{
        sidebarState: {
          isSidebarOpened,
          setIsSidebarOpened
        }
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};